import styled from 'styled-components';
import { colors } from '@/styles';

export const LinkCell = styled.div`
  display: flex;
  height: 100%;
  padding: 4px;
  & > * {
    display: flex;
  }
`;

export const LinkDetails = styled.div`
  padding: 5px 10px;
`;
